<template id="popup">
	<div class="page page-popup" v-on:click="close" title="返回" v-show="show">
		<transition name="fade">
		<div class="page-popup-content" v-on:click="stopClose($event)" title="" v-show="show">
			<div class="box">
				<div class="box-inner" v-html="html">			
				</div>
			</div>
			<div class="btn-close" v-on:click="close"></div>
			
		</div>
		</transition>
	</div>
</template>
<script>
import $ from 'jquery'
export default {
	props: [
		'html',
		'show'
	],
	watch: {
		show: function(v) {
			if (v) {
				this.open();
			} else {
				this.close();
			}
		}
	},
	data: function() {
		return {
			
		}
	},
	mounted: function() {

		
	},
	methods: {
		open: function() {
			// $(this.$el).show();
			// alert()
			$('body').css({overflow: 'hidden'})

		},
		close: function() {
			this.$emit('before-close');
			$('body').css({overflow: 'auto'})

		},
		stopClose: function(event) {
			event.stopPropagation();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Popup.vue